<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <!-- <el-col>
                    <el-button plain class="add-column-btn bbox" @click="gotoDetail('')" type="primary"> <i class="el-icon-plus fw900 f16"></i> 新增</el-button>
                </el-col> -->
        <el-col>
          <div class="top">
            <div class="header-search-box">
              <el-input
                placeholder="请输入商品名称"
                clearable
                v-model="productName"
                class="header-search-input ml10"
                style="width:200px;"
              ></el-input>
            </div>
            <div class="block">
              <el-date-picker
                v-model="dateRange"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:250px;"
              >
              </el-date-picker>
              <div class="search-btn">
                <el-button type="primary" @click="search()">搜索</el-button>
                <el-button @click="exportXls" type="primary">导出</el-button>
              </div>
            </div>
          </div>
        </el-col>
        <!-- <el-col>
          <div>
            <el-button type="primary" @click="exportXls()">导出</el-button>
          </div>
                 </el-col> -->
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              @sort-change="sortChange"
            >
              <!-- <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column type="selection" width="45" align="center">
              </el-table-column>
              <el-table-column
                label="产品分类名称"
                align="center"
                prop="产品分类名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.categoryName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="商品名称" align="center" prop="商品名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.productName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="商品单价" align="center" prop="商品单价">
                <template slot-scope="scope">
                  <span>{{ scope.row.normalPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" align="center" prop="数量">
                <template slot-scope="scope">
                  <span>{{ scope.row.saleNum }}</span>
                </template>
              </el-table-column>
              <el-table-column label="销售金额" align="center" prop="销售金额">
                <template slot-scope="scope">
                  <span v-if="scope.row.totalFee!='' && scope.row.totalFee!=null"
                  >{{ scope.row.totalFee }}</span>
                  <span v-else>
                    {{ scope.row.normalPrice * scope.row.saleNum }}
                  </span>
                </template>
              </el-table-column>

              <!-- <el-table-column label="商家编码" align="center"  prop="商家编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商家名称" align="center"  prop="商家名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="订单号" align="center"  prop="订单号" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderNumber }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="流水号" align="center"  prop="流水号" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.transNo }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品编码" align="center"  prop="产品编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.productCode }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="产品分类编码" align="center"  prop="产品分类编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.categoryCode }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="桌台编码" align="center"  prop="桌台编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.tableCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="桌台名称" align="center"  prop="桌台名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.tableName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品大类编码" align="center"  prop="产品大类编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.classCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品大类名称" align="center"  prop="产品大类名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.className }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" align="center"  prop="单位" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.unit }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="辅助单位" align="center"  prop="辅助单位" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.assiUnit }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="正常单价" align="center"  prop="正常单价" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.normalPrice }}</span>
                        </template>
                    </el-table-column>


                    <el-table-column label="剩余数量" align="center"  prop="剩余数量" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.assiAmount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="折扣率" align="center"  prop="折扣率" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.discountRate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付价格" align="center"  prop="支付价格" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.payPrice }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="生产日期" align="center"  prop="生产日期" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.producedDt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="制作人编码" align="center"  prop="制作人编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.producerCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="制作人名称" align="center"  prop="制作人名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.producerName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否已制作" align="center"  prop="是否已制作" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isProduced }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" align="center"  prop="状态" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.status }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="制作部门" align="center"  prop="制作部门" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.makeDepart }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="制作成本" align="center"  prop="制作成本" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.makeCostPrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="赠送人员编码" align="center"  prop="赠送人员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.presentUserCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="赠送人员名称" align="center"  prop="赠送人员名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.presentUserName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否已支付" align="center"  prop="是否已支付" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isPay }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否已发送" align="center"  prop="是否已发送" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isSend }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="发送时间" align="center"  prop="发送时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.sendTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="点单时间" align="center"  prop="点单时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="点单人员编码" align="center"  prop="点单人员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderUserCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="点单人员名称" align="center"  prop="点单人员名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderUserName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否加菜" align="center"  prop="是否加菜" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isAdd }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否赠送" align="center"  prop="是否赠送" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isPresent }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否折扣" align="center"  prop="是否折扣" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isDiscount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否是称重商品" align="center"  prop="是否是称重商品" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isWeighSell }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="营业日期" align="center"  prop="营业日期" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.businessDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售人员编码" align="center"  prop="销售人员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.salesManCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售人员名称" align="center"  prop="销售人员名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.salesManName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="含税价" align="center"  prop="含税价" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.containTaxPrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="含税金额" align="center"  prop="含税金额" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.containTaxSum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="税额" align="center"  prop="税额" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.taxSum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="成本均价" align="center"  prop="成本均价" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.costAvgPrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="成本金额" align="center"  prop="成本金额" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.costSum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="毛利" align="center"  prop="毛利" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.grossProfit }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="毛利率" align="center"  prop="毛利率" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.grossProfitRate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="销售比重" align="center"  prop="销售比重" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.saleWeight }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="毛利比重" align="center"  prop="毛利比重" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.grossProfitWeight }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="连锁编码" align="center"  prop="连锁编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.groupCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="连锁名称" align="center"  prop="连锁名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.groupName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" align="center"  prop="备注" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.remark }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="退货数量" align="center"  prop="退货数量" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.returnNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="订单列表图" align="center"  prop="订单列表图" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.padImg }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="列表图" align="center"  prop="列表图" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.listImg }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="详情图" align="center"  prop="详情图" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.detailImg }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品做法" align="center"  prop="商品做法" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.practicesJson }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column
                        label="操作"
                        align="center"
                        class-name="small-padding fixed-width"
                >
                    <template slot-scope="scope">
                        <el-tooltip
                                class="item"
                                effect="dark"
                                content="编辑"
                                placement="bottom"
                        >
                            <i
                                    class="el-icon-edit textblue f16"
                                    @click="gotoDetail(scope.row.id, scope.row.userCode)"
                            ></i>
                        </el-tooltip>
                        <el-tooltip
                                class="item"
                                effect="dark"
                                content="删除"
                                placement="bottom"
                        >
                            <i
                                    class="el-icon-delete textblue f16 ml20"
                                    @click="del(scope.row.id)"
                            ></i>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
            </el-table>
          </el-row></el-scrollbar
        >
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      dateRange: "",
      productName: "",
      categoryName: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.productName = this.productName;
      this.queryInfo.condition.categoryName = this.categoryName;
      if (this.dateRange) {
        let arr = [];
        arr = this.dateRange.toString().split(",");
        this.queryInfo.condition.startDt = arr[0];
        this.queryInfo.condition.endDt = arr[1];
      } else {
        this.queryInfo.condition.startDt = null;
        this.queryInfo.condition.endDt = null;
      }

      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantOrderItem/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantOrderItems/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.merchantCode = localStorage.getItem(
        "merchantCode"
      );
      that.$http
        .post("/productDetails/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            this.queryInfo.condition.productName = "";
            this.queryInfo.condition.categoryName = "";
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    exportXls() {
      var that = this;
      let data = {};
      data.merchantCode = localStorage.getItem("merchantCode");
      that.$http.post("/productDetails/exportXls", data).then(res => {
        if (res.data.code == 200) {
          window.open(res.data.data)
          that.$message.success("导出成功");
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.top {
  display: flex;
}
.block {
  display: flex;
  margin-left: 10px;
}
.search-btn {
  display: flex;
  margin-left: 10px;
}
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

/deep/ .top .el-input__inner {
  height: 38px !important;
  border-radius: 2px;
}
/deep/.top .el-input__inner::placeholder {
  font-size: 16px;
}
/deep/ .top .el-button {
  height: 37px;
  border-radius: 2px;
}
</style>
